import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

interface Device {
    id?: string;
    nickname: string;
    number: string;
    xmcPrice: string;
    footerText: string;
    imgUrl?: string;
    lineIdKey?: string;
}

interface DeviceSelectionEvent {
    device: Device;
    isSelected: boolean;
    index: number;
    lineIdKey?: string;
}

@Component({
    selector: 'xm-consent-devices-card',
    templateUrl: './consent-devices-card.html',
    styleUrls: ['./consent-devices-card.scss'],
    standalone: false
})
export class XmConsentDevicesCardComponent implements OnInit {
    @Input() public device: Device;
    @Input() public index: number;
    @Input() public isSelectable: boolean = true;
    @Input() public initialValue: boolean = false;
    @Output() public selectionChange: EventEmitter<DeviceSelectionEvent> = new EventEmitter<DeviceSelectionEvent>();

    public control: FormControl;

    public ngOnInit(): void {
        this.control = new FormControl(this.initialValue);
        
        this.control.valueChanges.subscribe((value: boolean) => {
            this.selectionChange.emit({
                device: this.device,
                isSelected: value,
                index: this.index,
                lineIdKey: this.device.lineIdKey
            });
        });
    }

    public get imageOptions(): MediaImageOptions {
        if (this.device?.imgUrl) {
            return {
                mobile: {
                    alt: this.device.nickname,
                    base: this.device.imgUrl
                }
            };
        }
    }

    public get checkboxId(): string {
        return `device-checkbox-${this.index}`;
    }

    public setValue(value: boolean): void {
        this.control.setValue(value);
    }

    public get value(): boolean {
        return this.control.value;
    }

    public get isValid(): boolean {
        return this.control.valid;
    }

    /**
     * Handles card click to toggle selection
     */
    public onCardClick(): void {
        if (this.isSelectable) {
            this.control.setValue(!this.control.value);
        }
    }

    /**
     * Handles keyboard navigation for accessibility
     * @param event KeyboardEvent
     */
    public onCardKeyDown(event: KeyboardEvent): void {
        if (this.isSelectable && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            this.onCardClick();
        }
    }
}
